<template>
  <header :class="cn('flex flex-col gap-1', props.class)">
    <span class="text-2.5xl font-semibold">
      {{ title }}
    </span>
    <span class="text-sm font-light text-black/50">
      {{ description }}
    </span>
  </header>
</template>

<script setup lang="ts">
const props = defineProps<{
  class?: ClassValue
  title?: string
  description?: string
}>()
</script>
